export default defineNuxtRouteMiddleware((to, from) => {
  if (to.query?.debug) {
    console.log({ to, from })
  }
})
